import React from "react"
import DisabledLineItem from "./DisabledLineItem"

class EmailAdressDataType extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.row && this.props.row.unconfirmed_email) {
      return (
        <DisabledLineItem key={this.props.row.id} data={this.props.row.unconfirmed_email} unconfirmed_email={true} />
      );
    } else if (this.props.data) {
        return (
          <div>{this.props.data}</div>
        );
    } else {
      return null;
    }
  }

};

export default EmailAdressDataType